// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1Xs2e","loaderOuter":"PageOverlayLoader_loaderOuter__1VFBn"};